import React, { FC } from "react";
import {
  ActiveStyled,
  BackIcon,
  Body,
  FormItem,
  Header,
  HeaderText,
  LeftSideWrapper,
  LoggedInStyled,
  ModalButtonsWrapper,
  PStyled,
  RightSideWrapper,
  SwitchWrapper,
  Wrapper,
  PopconfirmTitleWrapper,
} from "./elements";
import back from "../../../assets/icons/back.svg";
import { Button } from "../../atoms/Button";
import { Col, Form, Popconfirm, Row, Select as AntSelect } from "antd";
import { validation } from "../../../constants";
import { InputWithLabel } from "../../molecules/InputWithLabel";
import { Wrapper as SelectWrapper } from "../../atoms/Select/elements";
import { theme } from "../../../config";
import { Switch } from "../../atoms/Switch";
import { Modal } from "../../organisms/Modal";
import { InputTitle } from "../../molecules/DatePickerWithLabel/elements";
import { exclamation } from "../../../assets/icons";
import { UserProps } from "./types";
const { Option } = AntSelect;

type Props = {
  onFinish: () => void;
  formRef: any;
  passwordFormRef: any;
  user: UserProps;
  onBack: () => void;
  textRules: object;
  onConfirmSwitch: () => void;
  onCancelSwitch: () => void;
  setShowModal: (value: boolean | ((prevVar: boolean) => boolean)) => void;
  accountActive: boolean;
  showModal: boolean;
  onCloseModal: () => void;
  onFinishPasswordForm: () => void;
  accountStatus?: boolean;
  currentUser?: any;
};

const UpdateUser: FC<Props> = ({
  onFinish,
  formRef,
  user,
  onBack,
  textRules,
  onConfirmSwitch,
  onCancelSwitch,
  setShowModal,
  accountActive,
  showModal,
  onCloseModal,
  onFinishPasswordForm,
  passwordFormRef,
  accountStatus,
  currentUser,
}) => {
  const fakePassword = "00000000";

  return (
    <>
      <Wrapper>
        <Form
          onFinish={onFinish}
          form={formRef}
          validateMessages={{
            required: "This is required",
            whitespace: "This is required",
          }}
          initialValues={{
            ...user,
            password: fakePassword,
            accountStatus: accountStatus,
          }}
        >
          <Header>
            <LeftSideWrapper>
              <BackIcon src={back} onClick={onBack} />
              <div>
                <HeaderText>Update User</HeaderText>
              </div>
            </LeftSideWrapper>
            <RightSideWrapper>
              <Button type={"primary"} htmlType={"submit"}>
                Save
              </Button>
            </RightSideWrapper>
          </Header>
          <Body>
            <Row gutter={[62, 23]}>
              <Col span={12}>
                <FormItem name="name" rules={[textRules]}>
                  <InputWithLabel
                    label={"Full Name"}
                    type={"default"}
                    noMarginTop={true}
                  />
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem name="email" rules={[textRules]}>
                  <InputWithLabel
                    label={"Email"}
                    type={"default"}
                    noMarginTop={true}
                  />
                </FormItem>
              </Col>
              <Col span={12}>
                <InputTitle>Access Type</InputTitle>
                <SelectWrapper>
                  <Form.Item
                    style={{ height: "0" }}
                    name="accessType"
                    rules={[textRules]}
                  >
                    <AntSelect>
                      <Option value={"interviewer"}>Interviewer</Option>
                      <Option value={"recruiter"}>Recruiter</Option>
                      {currentUser?.isSuperAdmin && <Option value={"admin"}>Admin</Option>}
                    </AntSelect>
                  </Form.Item>
                </SelectWrapper>
              </Col>
              <Col span={12}>
                <FormItem name="password" rules={[textRules]}>
                  <InputWithLabel
                    label={"Password"}
                    type={"password"}
                    noMarginTop={true}
                    disabled={true}
                  />
                </FormItem>
              </Col>
              <Col span={12}></Col>
              <Col>
                <PStyled onClick={() => setShowModal(true)}>
                  Reset Password
                </PStyled>
              </Col>
              <Col span={12}></Col>
              <Col span={12}>
                <div style={{ marginTop: "-13px" }}>
                  <p style={{ color: theme.colors.dark }}>Account Status</p>
                  <SwitchWrapper>
                    <Popconfirm
                      placement="bottomRight"
                      title={
                        <PopconfirmTitleWrapper>
                          <img src={exclamation} alt="project icon" />
                          <p>
                            Are you sure you want to update the user's account
                            status?
                          </p>
                        </PopconfirmTitleWrapper>
                      }
                      onConfirm={onConfirmSwitch}
                      onCancel={onCancelSwitch}
                      okText="Yes"
                      cancelText="Cancel"
                    >
                      <Switch checked={accountActive} />
                    </Popconfirm>
                    <ActiveStyled>
                      {accountActive ? "Active" : "Suspended"}
                    </ActiveStyled>
                    <LoggedInStyled>
                      |&nbsp;&nbsp;
                      {accountActive ? "Logged in" : "Logged out"}
                    </LoggedInStyled>
                  </SwitchWrapper>
                </div>
              </Col>
            </Row>
          </Body>
        </Form>
      </Wrapper>
      <Modal
        visible={showModal}
        onModalClose={onCloseModal}
        title={"Reset Password"}
        body={
          <Form
            onFinish={onFinishPasswordForm}
            form={passwordFormRef}
            validateMessages={{
              required: "This is required",
              pattern: {
                mismatch: validation.validateMessages.password as any,
              },
            }}
          >
            <Form.Item
              name="password"
              rules={[
                {
                  required: true,
                  message: "This field is required",
                },
                { pattern: validation.passwordValidation },
              ]}
            >
              <InputWithLabel
                label={"New Password"}
                type={"password"}
                noMarginTop={true}
              />
            </Form.Item>
            <Form.Item
              name="confirmPassword"
              dependencies={["password"]}
              rules={[
                {
                  required: true,
                  message: "This field is required",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error("Passwords do not match"));
                  },
                }),
              ]}
            >
              <InputWithLabel
                label={"Re-enter New Password"}
                type={"password"}
              />
            </Form.Item>
            <ModalButtonsWrapper>
              <Button type={"primary"} id={"cancel_btn"} onClick={onCloseModal}>
                Cancel
              </Button>
              <Button type={"primary"} htmlType={"submit"}>
                Reset
              </Button>
            </ModalButtonsWrapper>
          </Form>
        }
      />
    </>
  );
};

export default UpdateUser;
